import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { ICreateBucketRequest } from "@shared/lib/types/influencer";
import { BucketService } from "../services/bucket.service";
import { BUCKET_LIST_QUERY_KEY } from "../constants";

export function useUpdateBucket(bucketId: string) {
  const {
    mutate: update,
    isLoading: isUpdating,
    isSuccess: isUpdated,
  } = useMutation<
    { bucket:ICreateBucketRequest; bucketId: string },
    void
  >({
    mutationFn: async ({bucketId,bucket}:{bucketId:string,bucket:ICreateBucketRequest}) => {
      return await BucketService.updateBucket(
        bucketId,
        bucket
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        //console.log(responseBody)
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    options: {
      queryKey: [...BUCKET_LIST_QUERY_KEY,bucketId],
      skipInvalidation: false,
    },
    onSuccess: (c, _, ) => {
          c.invalidateQueries({ queryKey: BUCKET_LIST_QUERY_KEY });
        },
  });

  return {
    update,
    isUpdating,
    isUpdated,
  };
}
